import React from 'react';
import { Phone, Clock, Car } from 'lucide-react';

const HeroSection = () => {
  const handleCall = () => {
    window.location.href = 'tel:731089300';
  };

  const scrollToMenu = () => {
    const element = document.getElementById('menu');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section
      className="relative min-h-screen flex items-center justify-center pt-20"
      style={{
        backgroundImage: 'url(https://customer-assets.emergentagent.com/job_fresh-eats-61/artifacts/2c8ibthq_Screenshot%202026-04-06%20at%2018.08.17.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/60"></div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 py-20 text-center">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
          <span className="text-yellow-400">Najlepszy Kebab</span>
          <br />
          <span className="text-yellow-400">w Chełmnie</span>
        </h1>

        <p className="text-white text-lg md:text-xl mb-12 max-w-2xl mx-auto">
          Autentyczne smaki w samym sercu miasta. Świeże składniki, doskonałe przyprawy i tradycyjne receptury.
        </p>

        {/* Call to action box */}
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl max-w-2xl mx-auto mb-8">
          <h2 className="text-red-500 text-2xl md:text-3xl font-bold mb-6">ZADZWOŃ i ZAMÓW</h2>

          <button
            onClick={handleCall}
            className="bg-red-500 hover:bg-red-600 text-white font-bold text-xl md:text-2xl py-4 px-8 rounded-full flex items-center justify-center gap-3 mx-auto mb-4 transition-all duration-200 transform hover:scale-105 shadow-lg"
          >
            <Phone size={28} />
            <span>731 089 300</span>
            <span className="text-2xl">→</span>
          </button>

          <p className="text-gray-700 mb-6">👆 Kliknij mnie i zamów!</p>

          <div className="space-y-3 text-gray-800">
            <p className="flex items-center justify-center gap-2 text-red-500 font-semibold">
              <Car size={20} />
              <span>Dowóz na terenie Chełmna za 6zł</span>
            </p>
            <p className="text-gray-600">Dowozimy w promieniu aż 15km!</p>
            <button className="flex items-center justify-center gap-2 mx-auto bg-red-500 text-white font-semibold py-3 px-6 rounded-full">
              <Clock size={20} />
              <span>Pon-Niedz: 12:00 - 21:30</span>
            </button>
          </div>
        </div>

        <button
          onClick={scrollToMenu}
          className="bg-yellow-400 hover:bg-yellow-500 text-black font-bold text-xl py-4 px-12 rounded-full transition-all duration-200 transform hover:scale-105 shadow-lg"
        >
          Zobacz Menu
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
